query TownSuggestion($key: String!, $maxResults: Int!) {
  townSuggestions(suggestion: { key: $key, maxResults: $maxResults }) {
    cid
    toponymsPath
  }
}

query CurrencyList {
  currencyList {
    currencyISOCode
    isActive
    name
  }
}
